import * as React from 'react'
import {
    ConfirmSignIn,
    RequireNewPassword,
    VerifyContact,
    withAuthenticator
} from 'aws-amplify-react'
import { SignUpWithData } from './SignUpWithData'
import { LoginWithData } from './LoginWithData'
import { ConfirmSignUpWithData } from './ConfirmSignUpWithData'
import { Welcome } from './Welcome'
import { ForgotPasswordWithData } from './ForgotPasswordWithData'
import { ProfilePageWithData } from './ProfilePageWithData'

// keep track of the password outside of the Authenticator component
// this is so that we can sign a user in after they confirm their account
let password = ''
const setPassword = (incoming: string) => password = incoming
const getPassword = () => password

const AccountPageWithData = withAuthenticator(ProfilePageWithData, {
    includeGreetings: false,
    authenticatorComponents: [
        <LoginWithData key='SignIn' />,
        <ConfirmSignIn key='ConfirmSignIn' />,
        <VerifyContact key='VerifyContact' />,
        <SignUpWithData key='SignUp' usernameAttributes='email' setPassword={setPassword} />,
        <ConfirmSignUpWithData key='ConfirmSignUp' usernameAttributes='email' getPassword={getPassword} />,
        <ForgotPasswordWithData usernameAttributes='email' key='ForgotPassword' />,
        <RequireNewPassword key='RequireNewPassword' />,
        <Welcome key='welcome' />,
    ],
})

export { AccountPageWithData }
